// Test IDs for the Capsule Calculator feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const CAPSULE = {
	// Bag → Capsules
	totalInput: 'capsule-total-input',
	totalUnitSelect: 'capsule-total-unit-select',
	fillInput: 'capsule-fill-input',
	sizeSelect: 'capsule-size-select',
	densitySelect: 'capsule-density-select',
	densityCustomInput: 'capsule-density-custom-input',
	purityInput: 'capsule-purity-input',
	resultCount: 'capsule-result-count',
	// Reverse
	capsulesInput: 'capsule-count-input',
	// Cost
	bagCostInput: 'capsule-bag-cost-input',
	// Actions
	copyButton: 'capsule-copy-button',
	saveInventoryButton: 'capsule-save-inventory-button',
	saveInventoryConfirm: 'capsule-save-inventory-confirm',
	medSelect: 'capsule-med-select',
};
